<template>
  <section class="help-page">
    <Header />
    <Main />
    <Footer />
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import Main from "@/components/installFf/Main";
import Footer from "@/components/landing/Footer";
import {updateMetaTag, updateCanonical} from "@/utils/useHeadUtils"

export default {
  components: {
    Header,
    Main,
    Footer,
  },
  mounted() {
    const title = 'Effortless Firefox Integration: Enable Required Permissions for Proper Extension Functionality';
    const description = 'To ensure smooth operation of the extension, follow these steps to enable the "Access your data for all websites" permission in Firefox. This step is essential for the extension to function properly across all sites.';

    document.title = title;
    updateMetaTag('description', description);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/install-ff');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.help-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
